<template>
  <div class="tw-w-full">
    <div class="tw-flex tw-gap-6 tw-w-full tw-items-start">
      <div class="tw-bg-white tw-rounded-lg tw-w-full">
        <CandidateCard
          :candidate="candidate"
          :projectId="projectId"
          :notes="candidate.note_to_hm"
        />
      </div>
      <div>
        <div v-if="candidate" class="tw-w-[310px]">
          <reasons
            v-bind:candidate="candidate"
            :tab="tab"
            :isPilot="isPilot"
            :isRecruiter="isRecruiter"
            :projectId="projectId"
            :displayClipBoard="displayClipBoard"
            :notes="candidate.note_to_hm"
            :projectData="projectData"
            :loadingTab="loadingTab"
            @expand-email="expandEmail"
          />
        </div>
      </div>
    </div>
    <div class="tw-fixed tw-left-1/2 -tw-translate-x-1/2 tw-bottom-0 tw-z-50">
      <div>
        <div
          v-if="totalCandidates > 1 && isPilot"
          class="tw-bg-purple-200 tw-rounded-t-lg tw-p-3 tw-gap-3 tw-flex tw-justify-center tw-items-center"
        >
          <v-btn
            icon
            width="24px"
            height="24px"
            color="#384955"
            :disabled="
              (candidateIndex === 0 && pageIdx === 1) || loading || isLoading
            "
            @click="previousCandidate()"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <Typography varaint="headline-7">
            {{ tabsNames[tab.toLowerCase()] }} candidate
            {{ (pageIdx - 1) * limit + candidateIndex + 1 }} of
            {{ totalCandidates }}
          </Typography>
          <v-btn
            icon
            width="24px"
            height="24px"
            color="#384955"
            :disabled="
              (pageIdx - 1) * limit + candidateIndex + 1 >= totalCandidates ||
              loading ||
              isLoading
            "
            @click="nextCandidate()"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div
          v-if="!readonly && size !== 'small' && !hideActions"
          class="tw-flex tw-bg-purple-200 tw-justify-center tw-p-3 tw-gap-3"
          :class="{
            'tw-border-0 tw-border-t tw-border-solid tw-border-purple-300':
              totalCandidates > 1 && isPilot,
            'tw-rounded-t-lg': totalCandidates === 1 || !isPilot,
          }"
        >
          <div>
            <RejectedBox
              :commentOnlyAccess="commentOnlyAccess"
              :candidate="candidate"
              :projectId="projectId"
              :projectSetting="currentProjectSettings"
              :isShowIntro="isShowIntro"
              :introStep="introStep"
              :contents="contents"
              :isShowIntro2="isShowIntro2"
              :contents2="contents2"
              :isFront="isFront"
              :iscurrentGolive="iscurrentGolive"
              :showFakeCard="showFakeCard"
              :isRecruiter="isRecruiter"
              :isCalibration="isInCalibration || isInCalibrationNewProject"
              :loading="isLoading"
              :loadingAction="loadingAction"
              @reject="handleReject"
              @keep="handleKeep"
              @changeIntroStep="introStep = 0"
              @closeHandler="closeHandler"
              @disable-right-side="onDisabledRightSide"
              @moveToWaitingReply="moveToWaitingReply"
            />
          </div>

          <div>
            <v-tooltip bottom :disabled="!commentOnlyAccess" max-width="15rem">
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  class="position-relative tw-flex tw-gap-2 tw-items-center"
                  v-on="on"
                >
                  <div v-if="isApprove">
                    <v-tooltip
                      top
                      :disabled="isInCalibration || isInCalibrationNewProject"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <Button
                            variant="approve"
                            :disabled="commentOnlyAccess || isLoading"
                            :loading="loadingAction === 'approve' && isLoading"
                            @click.prevent="approve"
                          >
                            <div
                              class="tw-flex tw-gap-3 tw-items-center tw-justify-center tw-min-w-[210px] tw-text-base"
                            >
                              <div>
                                <img :src="LikeIcon" />
                              </div>
                              <div>
                                {{
                                  isInCalibration || isInCalibrationNewProject
                                    ? 'Approve'
                                    : 'Schedule interview'
                                }}
                              </div>
                            </div>
                          </Button>
                        </div>
                      </template>
                      <div class="tw-w-[275px] tw-text-white tw-py-2">
                        <Typography variant="body-2">
                          Click on “Schedule Interview” to move forward with
                          this candidate for a first interview. Upon clicking
                          this button, Hirefly will send an instant intro email
                          to you and the candidate and prompt the candidate to
                          schedule time with you.
                        </Typography>
                      </div>
                    </v-tooltip>

                    <HotSpot
                      v-if="isShowIntro && isFront && iscurrentGolive"
                      title="Approve"
                      :contents="contents"
                      :value="introStep"
                      :hideClose="true"
                      :isTooltip="true"
                      @close="isShowIntro = false"
                      @next="introStep += 1"
                    />
                  </div>
                  <send-to-review
                    v-if="isSentToReview"
                    :tab="tab"
                    :candidate="candidate"
                    :projectId="projectId"
                    :disabled="commentOnlyAccess || isShowIntro2 || isLoading"
                    v-on:move="sendToReview"
                  />
                  <AcceptSatisfaction
                    v-if="isAcceptSatisfaction"
                    :disabled="commentOnlyAccess || isShowIntro2 || isLoading"
                    :isFront="isFront"
                    :iscurrentGolive="iscurrentGolive"
                    :isShowIntro2="isShowIntro2"
                    :introStep="introStep2"
                    :showFakeCard="showFakeCard"
                    @submit="submitAcceptSatisfaction"
                    @close="introStep += 1"
                    @closeInfo="$emit('closeInfo')"
                  />
                </div>
              </template>
              <span>You don't have permissions to perform this action</span>
            </v-tooltip>
          </div>
          <div
            v-if="(isPilot && !isInCalibration) || !isPilot"
            class="tw-ml-1 tw-pr-1 tw-relative"
          >
            <div
              class="tw-absolute tw--top-3 tw-border-0 tw-border-l tw-border-solid tw-border-purple-300 tw-h-[75px]"
            ></div>
          </div>
          <div v-if="(isPilot && !isInCalibration) || !isPilot">
            <v-menu
              v-model="move1"
              top
              nudge-top="32px"
              max-width="200"
              :disabled="isLoading"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <Button
                    variant="text"
                    class="tw-text-center"
                    :loading="moveingLoading"
                  >
                    <div>
                      <img :src="MoveIcon" class="tw-inline" />
                    </div>
                    <Typography
                      variant="caption"
                      class="tw-font-normal tw-text-purple-600"
                      >Move</Typography
                    >
                  </Button>
                </div>
              </template>
              <div
                class="tw-bg-white tw-shadow-shadow-2 tw-rounded tw-w-[200px] tw-max-h-[300px] tw-overflow-auto"
              >
                <div>
                  <Typography variant="body-2">
                    <div
                      v-if="!isPilot"
                      class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                      @click="onMoveClick('contacted')"
                    >
                      Contacted
                    </div>
                    <div
                      v-if="
                        isPilot &&
                        isRecruiter &&
                        tab !== 'WARM_LEADS_QUESTION' &&
                        tab !== 'QUESTION'
                      "
                      class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                      @click="onMoveClick('warm_leads_question')"
                    >
                      Needs Attention
                    </div>
                    <div
                      v-if="
                        isPilot &&
                        isRecruiter &&
                        tab !== 'WARM_LEADS_AWAITING_INFO' &&
                        tab !== 'AWAITING_INFO'
                      "
                      class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                      @click="onMoveClick('warm_leads_awaiting_info')"
                    >
                      Awaiting Reply
                    </div>
                    <v-menu
                      v-if="isRecruiter"
                      v-model="move2"
                      right
                      nudge-right="180px"
                      max-width="200"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <div
                            class="tw-flex tw-justify-between tw-items-center tw-group tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer tw-relative"
                          >
                            Not Interested
                            <v-icon size="12"> fas fa-chevron-right </v-icon>
                          </div>
                        </div>
                      </template>
                      <div
                        class="tw-w-[200px] tw-max-h-[300px] tw-overflow-auto tw-bg-white tw-shadow-shadow-2 tw-rounded-lg tw-z-50"
                      >
                        <div
                          v-for="(item, index) in notInterestedReasons"
                          :key="`not-interested-${index}`"
                          class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                          @click="
                            () => {
                              onNotInterectedClick(item.key);
                            }
                          "
                        >
                          <span>{{ item.title }} </span>
                        </div>
                      </div>
                    </v-menu>
                    <div
                      v-if="isPilot"
                      class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                      @click="onMoveClick('warm_leads_hm_approved')"
                    >
                      Scheduling
                    </div>
                    <div
                      class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                      @click="onMoveInterviewClick('INTERVIEWING')"
                    >
                      Interview
                    </div>
                    <v-menu
                      v-model="move3"
                      right
                      nudge-right="180px"
                      max-width="200"
                      close-on-content-click
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <div
                            class="tw-group tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer tw-relative"
                          >
                            Other Projects
                            <v-icon size="12"> fas fa-chevron-right </v-icon>
                          </div>
                        </div>
                      </template>
                      <div
                        class="tw-w-[200px] tw-max-h-[300px] tw-overflow-auto tw-bg-white tw-shadow-shadow-2 tw-rounded-lg tw-z-50"
                      >
                        <div
                          v-for="(item, index) in allProjectsRoles"
                          :key="`projName_${index}`"
                          :title="
                            item.project_name &&
                            item.project_name.length > numberOfLength
                              ? item.project_name
                              : null
                          "
                        >
                          <v-menu right nudge-right="180px" max-width="200">
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on">
                                <div
                                  class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer tw-relative"
                                >
                                  {{ item.project_name }}
                                  <v-icon size="12">
                                    fas fa-chevron-right
                                  </v-icon>
                                </div>
                              </div>
                            </template>
                            <div
                              class="tw-w-[200px] tw-max-h-[300px] tw-overflow-auto tw-bg-white tw-shadow-shadow-2 tw-rounded-lg tw-z-50"
                            >
                              <div
                                class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                                @click="
                                  () => {
                                    onOtherProjectClick(item.project_id);
                                  }
                                "
                              >
                                Interested
                              </div>
                              <div
                                class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                                @click="
                                  () => {
                                    onOtherProjectClick(
                                      item.project_id,
                                      'WARM_LEADS_QUESTION'
                                    );
                                  }
                                "
                              >
                                Needs Attention
                              </div>
                            </div>
                          </v-menu>
                        </div>
                      </div>
                    </v-menu>
                  </Typography>
                </div>
              </div>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="interviewConfirmationDialog" width="25rem" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Interview Confirmation
        </v-card-title>

        <v-card-text class="mt-4">
          Hirefly will contact the candidate to schedule the interview.
        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#999" text @click="interviewConfirmationDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primaryDark" text @click="schedule"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isSuccessSending" width="444">
      <v-card class="success-popup">
        <v-card-text class="pt-4 success-title">
          <v-icon size="22" right color="#4CAF50">
            mdi-checkbox-marked-circle
          </v-icon>
          <span>Success!</span>
        </v-card-text>
        <v-card-text class="mt-0">
          {{ successMessage }}
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isCalendarProcess" width="25rem" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Calendar setup required
        </v-card-title>

        <v-card-text class="mt-4">
          It seems you have not set up your calendar yet. We cannot schedule
          candidate interviews until you do
        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#999" text @click="isCalendarProcess = false">
            Cancel
          </v-btn>
          <v-btn color="primaryDark" text @click="goToCalendar">
            Go to Calendar Page
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isMoveNotInterested" width="444">
      <div class="tw-bg-white tw-rounded-lg tw-p-6">
        <Typography variant="headline-6">
          Move candidate to not interested
        </Typography>
        <Typography variant="body-2" class="tw-mt-4 tw-mb-3">
          {{ movingNotInterestedReason === 1 ? 'Misclassification' : 'Other ' }}
        </Typography>
        <v-text-field
          v-if="movingNotInterestedReason == 8"
          v-model="not_interested_reason_other"
          rows="1"
          hide-details
          placeholder="Other reasons..."
          :rules="[rules.reasonText2]"
          :disabled="movingNotInterestedReason != 8"
        />
        <v-text-field
          v-if="movingNotInterestedReason == 1"
          v-model="not_interested_reason_other"
          rows="1"
          placeholder="Input reasons..."
          hide-details
          :rules="[rules.reasonText2]"
        />
        <div class="tw-mt-8 tw-flex tw-justify-between tw-gap-3">
          <Button variant="text" @click="isMoveNotInterested = false"
            >Cancel</Button
          >
          <Button
            :loading="sendButtonLoading"
            :disabled="!isValidSend"
            @click="moveCard"
            >Move</Button
          >
        </div>
      </div>
    </v-dialog>
    <v-snackbar v-model="copySuccessSnackBar"
      >Candidate Succesfully Moved To Other Project</v-snackbar
    >
    <v-snackbar v-model="errorMessage.error">{{
      errorMessage.message
    }}</v-snackbar>
    <v-snackbar v-model="snackbar" timeout="3000">{{ message }}</v-snackbar>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { mapState } from 'vuex';
import Config from '@/js/config';
import constants from '@/js/constants';
import FakeImage from '@/assets/img/fake-card.png';
import RejectedBox from '@/components/card/RejectedBox';
import CandidateCard from '@/components/v3/widgets/CandidateCard';
import Button from '@/components/v3/base/Button';
import Typography from '@/components/v3/base/Typography';
import LikeIcon from '@/assets/icons/thumbs-up.svg';
import MoveIcon from '@/assets/icons/move-icon.svg';
import { tabsNames } from '@/components/v3/widgets/tabs.ts';
import Reasons from './Reasons';
import SendToReview from './SendToReview';
import AcceptSatisfaction from './AcceptSatisfaction';
import HotSpot from '../information-tours/HotSpot';

export default {
  name: 'CardV2',
  components: {
    Reasons,
    SendToReview,
    AcceptSatisfaction,
    HotSpot,
    RejectedBox,
    CandidateCard,
    Button,
    Typography,
  },

  filters: {
    roundWholeNumber(value) {
      if (!value) return 0;
      return Math.round(Number(value));
    },
  },

  props: [
    'size',
    'candidate',
    'readonly',
    'hideActions',
    'projectId',
    'isInCalibration',
    'isInCalibrationNewProject',
    'currentUserRole',
    'tab',
    'isFront',
    'iscurrentGolive',
    'isShowIntro2',
    'introStep2',
    'showFakeCard',
    'displayClipBoard',
    'projectData',
    'currentTab',
    'totalCandidates',
    'candidateIndex',
    'pageIdx',
    'limit',
    'loading',
    'isLoading',
  ],

  data() {
    const tabs = [
      'experience',
      'education',
      'skills',
      'summary',
      'recommendations',
    ];
    const availableTab =
      tabs.find((tab) => !this.isTabDisabled(tab)) || 'empty';
    return {
      schedulePayload: {},
      movingProjectName: '',
      movingTabName: '',
      copySuccessSnackBar: false,
      errorMessage: {
        error: false,
        message: 'Candidate is already in this project.',
      },

      sendButtonLoading: false,
      status: '',
      disabled: false,
      candidateTabs: tabs,
      currentCandidateTab: availableTab,
      interviewConfirmationDialog: false,
      isActive: false,
      moveTo: 'warm_leads_question',
      rules: {
        reasonText2: (value) => {
          // console.log('In reason text validation');
          if (
            (this.movingNotInterestedReason === 8 ||
              this.movingNotInterestedReason === '8') &&
            !value
          ) {
            return 'This field is required.';
          }
          return true;
        },
      },

      loadingTab: false,
      moveingLoading: false,
      isCalendarProcess: false,
      FakeImage,
      notInterestedReasons: [
        {
          key: 1,
          title: 'Misclassification',
        },
        {
          key: 2,
          title: 'Timing',
        },
        {
          key: 3,
          title: 'Compensation',
        },
        {
          key: 4,
          title: 'Seniority',
        },
        {
          key: 5,
          title: 'Remote Work Policy',
        },
        {
          key: 6,
          title: 'Company Fit',
        },
        {
          key: 7,
          title: 'Work/Visa Status',
        },
        {
          key: 9,
          title: 'Role Fit',
        },
        {
          key: 12,
          title: 'Wrong Person/Email',
        },
        {
          key: 8,
          title: 'Other',
        },
      ],

      movingNotInterestedReason: '',
      not_interested_reason_other: '',
      introStep: 0,
      isShowIntro: true,
      contents: [
        'Click <strong>Approve</strong> to train Hirefly’s AI to find more similar candidates. Upon clicking this button, Hirefly will send out an initial outreach email to the candidate. Any interested candidates will then be presented to set up a first interview.',
        'Click <strong>Reject</strong> to reject this candidate. <br/> Hirefly’s AI will prompt you for a rejection reason to better adapt its search for the future. Hirefly will not share your rejection reason with the candidate. Rejected candidates will be sent to the ‘Rejected’ tab in your pipeline.',
      ],

      contents2: [
        'Click “Reject” to decline a candidate’s interview request. Hirefly’s AI will prompt you for a rejection reason to better adapt its search for the future. Hirefly will inform the candidate of your decision but will not share your rejection reason or any notes in its correspondence. ',
      ],

      snackbar: false,
      message: '',
      LikeIcon,
      MoveIcon,
      isMoveNotInterested: false,
      tabsNames,
      loadingAction: '',
      move1: false,
      move2: false,
      move3: false,
    };
  },

  computed: {
    ...mapState({
      user: 'user',
    }),

    isValidSend() {
      if (this.moveTo === 'other_project') {
        return this.movingProjectName !== '' && this.movingTabName !== '';
      }
      if (
        this.moveTo === 'not_interested' &&
        (!this.movingNotInterestedReason ||
          ((this.movingNotInterestedReason === 8 ||
            this.movingNotInterestedReason === '8') &&
            !this.not_interested_reason_other))
      ) {
        return false;
      }
      return true;
    },

    numberOfLength() {
      return this.movingProjectName !== '' ? 12 : 35;
    },

    currentClass() {
      if (this.status === 'approved') {
        return 'container approved';
      }
      if (this.status === 'rejected') {
        return 'container rejected';
      }
      if (this.status === 'contacted') {
        return 'container small contacted';
      }
      return 'container';
    },

    customArticle() {
      if (
        this.isPilot &&
        !this.currentProjectSettings.is_in_auto_swipe_calibration && // TODO(jeremiah): delete this line after v2 rollout
        !this.currentProject.status === '6'
      ) {
        return 'custom-article';
      }
      return '';
    },

    currentTabComponent() {
      return `tab-${this.currentCandidateTab.toLowerCase()}`;
    },

    commentOnlyAccess() {
      return this.currentUserRole === 3;
    },

    projects() {
      return this.$store.getters['projects/listProjects'];
    },

    currentProject() {
      if (!this.projectId) {
        return {};
      }

      const foundProject = this.projects.find(
        (project) => project.project_id === this.projectId
      );
      if (foundProject) return foundProject;
      return {};
    },

    isPilot() {
      return this.currentProject
        ? this.currentProject.in_auto_swipe_mode || // TODO(jeremiah): delete this after v2 rollout
            this.currentProject.type === '1' ||
            this.currentProject.type === '3'
        : false;
    },

    isRecruiter() {
      return (
        this.currentProject.is_warmleads_recruiter || // TODO(jeremiah): delete this after v2 migration
        this.$store.getters['user/getIsSuperAdmin']
      );
    },

    isSentToReview() {
      return (
        (this.tab === 'WARM_LEADS_RECRUITER' ||
          this.tab === 'AUTOPILOT_RECRUITER' ||
          this.tab === 'QUESTION' ||
          this.tab === 'WARM_LEADS_QUESTION' ||
          this.tab === 'WARM_LEADS_HM' ||
          this.tab === 'HIRING_MANAGER') &&
        this.isPilot &&
        this.isRecruiter
      );
    },

    isApprove() {
      return this.tab === 'UNDER_REVIEW';
    },

    isAcceptSatisfaction() {
      return !this.isSentToReview && !this.isApprove;
    },

    allProjectsRoles() {
      const adminProjects = [];
      for (const i in this.projects) {
        if (
          this.projects[i].role !== 3 &&
          this.projects[i].project_name !== this.currentProjectSettings.name && // TODO(jeremiah): delete this after V2 rollout
          this.projects[i].project_name !== this.currentProject.project_name &&
          !this.projects[i].is_archived &&
          !this.projects[i].outreach_pause
        ) {
          adminProjects.push(this.projects[i]);
        }
      }
      return adminProjects.sort((a, b) => a < b);
    },

    movedProjectIsAutopilot() {
      const foundProject = this.projects.find(
        (project) => project.project_id === this.movingProjectName
      );
      if (foundProject) {
        return foundProject.in_auto_swipe_mode;
      }
      return false;
    },

    isDisabledOtherProjects() {
      if (
        this.allProjectsRoles &&
        this.allProjectsRoles.length > 0 &&
        this.commentOnlyAccess === false
      ) {
        return true;
      }
      return false;
    },

    isSuccessSending() {
      return this.$store.getters['projects/candidates/getIsSuccess'];
    },

    successMessage() {
      return this.$store.getters['projects/candidates/getSuccessMessage'];
    },

    linkedinProfile() {
      const linkedinUrlInLinkedAccounts =
        this.candidate?.linked_accounts?.linkedin?.[0];
      const linkedinUrl =
        this.candidate?.linkedin_profile_url ?? linkedinUrlInLinkedAccounts;
      const userEmail = localStorage.getItem('email') ?? '';
      return userEmail && constants.RECRUITER_PROFILE_USERS.includes(userEmail)
        ? this.candidate?.linkedin_recruiter_url
        : linkedinUrl;
    },

    currentProjectSettings() {
      if (!this.projectId) {
        return {};
      }
      return this.$store.getters['projects/settings/getSettingsByProjectId'](
        this.projectId
      );
    },

    isV2() {
      return this.$store.getters['user/getIsUserV2'];
    },
  },

  watch: {
    isRecruiter() {
      this.moveTo =
        this.isRecruiter &&
        this.tab !== 'WARM_LEADS_QUESTION' &&
        this.tab !== 'QUESTION'
          ? 'warm_leads_question'
          : 'not_interested';
    },

    movingNotInterestedReason() {
      this.not_interested_reason_other = '';
    },

    currentTab(v) {
      if (v.toUpperCase() === this.tab.toUpperCase()) {
        this.loadingTab = false;
      } else {
        this.loadingTab = true;
      }
    },
  },

  mounted() {
    this.moveTo =
      this.isRecruiter &&
      this.tab !== 'WARM_LEADS_QUESTION' &&
      this.tab !== 'QUESTION'
        ? 'warm_leads_question'
        : 'not_interested';

    document.body.addEventListener('click', this.handleClickOutside);
    if (this.currentTab.toUpperCase() === this.tab.toUpperCase()) {
      this.loadingTab = false;
    } else {
      this.loadingTab = true;
    }
  },

  unmounted() {
    document.body.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    onDisabledRightSide(e) {
      this.$emit('disabled-right-side', e);
    },

    closeHandler() {
      this.isShowIntro = false;
      // go to thank you page
      this.$emit('closeIntro');
    },

    submitAcceptSatisfaction(payload) {
      this.schedulePayload = payload;
      this.schedule();
    },

    handleClickOutside(e) {
      if (!e.target.closest('.move-card-container')) {
        this.isActive = false;
      }
    },

    changeState(value) {
      this.isActive = value;
    },

    async moveCard() {
      if (!this.isValidSend) {
        return;
      }
      if (this.moveTo !== 'other_project') {
        this.status = 'approved';
        this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
          candidate: this.candidate,
          field: 'processed',
          value: true,
        });
        let payload = null;
        if (this.moveTo === 'not_interested') {
          payload = {
            not_interested_code: this.movingNotInterestedReason,
            not_interested_reason_other:
              this.movingNotInterestedReason === 8 ||
              this.movingNotInterestedReason === '8' ||
              this.movingNotInterestedReason === 1 ||
              this.movingNotInterestedReason === '1'
                ? this.not_interested_reason_other
                : '',
          };
        }
        const newTab = this.isV2
          ? constants.TABS_V1_TO_V2_MAP[this.moveTo.toUpperCase()].toLowerCase()
          : this.moveTo;
        this.$emit('movecard', {
          candidate: this.candidate,
          newTab,
          payload,
        });
        setTimeout(() => {
          this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
            candidate: this.candidate,
            field: 'status',
            value: newTab,
          });
        }, 500);
      } else {
        this.moveingLoading = true;
        this.sendButtonLoading = true;
        const res = await this.$store.dispatch(
          'projects/candidates/copyCandidate',
          {
            projectId: this.projectId,
            movingTabName: this.movingTabName,
            candidateId: this.candidate._id,
            movingProjectId: this.movingProjectName,
            tab: this.currentTab.toUpperCase(),
          }
        );
        if (res) {
          this.copySuccessSnackBar = true;
          this.$emit('next');
        } else {
          this.sendButtonLoading = false;
          this.errorMessage.error = true;
        }
        this.sendButtonLoading = false;
        this.moveingLoading = false;
      }
    },

    handleReject(e) {
      this.$emit('reject', e);
      this.loadingAction = 'reject';
    },

    moveToWaitingReply() {
      if (
        !this.isPilot ||
        !this.isRecruiter ||
        this.tab === 'WARM_LEADS_AWAITING_INFO' ||
        this.tab === 'AWAITING_INFO'
      )
        return;
      this.snackbar = true;
      this.message = `This candidate will reappear in your ‘Interested’ tab once they share the requested item with us. You can download their resume or portfolio by clicking the 'Resume' in the candidate card.`;
      this.moveTo = 'warm_leads_awaiting_info';
      this.handleChange();
      this.moveCard();
    },

    async approve() {
      // Prevent approval on projects if phone screener hasn't set up calendar sync
      this.loadingAction = 'approve';
      if (
        this.currentProjectSettings.phone_screener_needs_calendar_auth &&
        !(this.isPilot && this.isInCalibration)
      ) {
        this.$emit('prevent-approve-need-calendar-sync');
        return;
      }
      this.$amplitude_client.logEvent({
        event_type: 'card_approve_fe',
        user_id: localStorage.getItem('email'),
        event_properties: {
          candidate_id: this.candidate._id,
          candidate_name: this.candidate.name,
          project_id: this.projectId,
        },
      });

      if (this.candidate.status === 'REJECTED') {
        // TODO(jeremiah): I don't think this block is ever hit
        this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
          candidate: this.candidate,
          field: 'status',
          value: 'approved',
        });
        this.disabled = true;
        this.$emit('approve');
      } else {
        this.status = 'approved';
        this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
          candidate: this.candidate,
          field: 'processed',
          value: true,
        });
        setTimeout(() => {
          this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
            candidate: this.candidate,
            field: 'status',
            value: 'approved',
          });
        }, 500);
        const tab = this.isInCalibration ? 'UNDER_REVIEW' : this.tab;
        if (
          this.isPilot &&
          this.isInCalibration &&
          this.isInCalibrationNewProject &&
          !this.$store.getters['user/getIsUserV2'] // TODO(jeremiah): clean this up after v2 rollout
        ) {
          // const flag = await this.$root.$refs.sendMail.sendMail(tab);
          // if (!flag) {
          this.$store.dispatch('projects/candidates/updateCandidateState', {
            projectId: this.projectId,
            tab,
            candidateId: this.candidate._id,
            newTab: 'APPROVED',
          });
          // }
        } else {
          this.$emit('approve', { candidateId: this.candidate._id });
        }
      }
    },

    handleKeep(e) {
      this.$emit('keep', e);
    },

    async scheduleV2() {
      const res = await this.$store.dispatch(
        'projects/candidates/approveCandidateHm',
        {
          project_id: this.projectId,
          candidate: this.candidate,
          approval_score: this.schedulePayload.approval_score,
          approval_comments: this.schedulePayload.approval_score_other,
        }
      );
      if (res && res.status === 200) {
        this.$emit('schedule', { candidateId: this.candidate._id });
      }
    },

    async schedule() {
      this.interviewConfirmationDialog = false;
      // Prevent approval on projects if phone screener hasn't set up calendar sync
      if (
        this.currentProjectSettings.phone_screener_needs_calendar_auth &&
        !(this.isPilot && this.isInCalibration)
      ) {
        this.$emit('prevent-approve-need-calendar-sync');
        return;
      }
      this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
        candidate: this.candidate,
        field: 'processed',
        value: true,
      });
      // TODO(jeremiah): clean this up after v2 rollout
      if (this.$store.getters['user/getIsUserV2']) {
        this.scheduleV2();
        return;
      }
      const res = await this.$store.dispatch(
        'projects/candidates/updateCandidateState',
        {
          projectId: this.projectId,
          tab: this.tab,
          candidateId: this.candidate._id,
          newTab: 'WARM_LEADS_HM_APPROVED',
          payload: this.schedulePayload,
        }
      );
      if (res === 417) {
        this.isCalendarProcess = true;
        return;
      }
      if (res && res.status === 200) {
        this.$emit('schedule', { candidateId: this.candidate._id });
        this.status = 'approved';
        setTimeout(() => {
          this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
            candidate: this.candidate,
            field: 'status',
            value: 'warm_leads_hm_approved',
          });
        }, 0);
      } else if (res && res.status === 417) {
        this.isCalendarProcess = true;
      }
      this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
        candidate: this.candidate,
        field: 'processed',
        value: false,
      });
    },

    getCandidateName(candidate) {
      if (candidate.name) return candidate.name;
      let name = '';
      if (candidate.first_name) name += candidate.first_name;
      if (candidate.last_name) name = `${name} ${candidate.last_name}`;
      return name;
    },

    goToCalendar() {
      this.$router.push('/calendar');
    },

    sendToReview() {
      this.status = 'approved';
      this.$emit('updateStatus');
    },

    isTabDisabled(tab) {
      let key = '';
      if (tab === 'experience') {
        key = 'experiences';
      } else if (tab === 'education') {
        key = 'education';
      } else if (tab === 'skills') {
        key = 'skills';
      } else if (tab === 'summary') {
        key = tab;
      } else if (tab === 'recommendations') {
        key = 'recommendations';
      }
      return (
        !this.candidate[key] ||
        (this.candidate[key] && !this.candidate[key].length)
      );
    },

    getCandidateResume(candidate) {
      // TODO(jeremiah): clean this up after v2 rollout
      let resumeUrl;
      if (this.$store.getters['user/getIsUserV2']) {
        resumeUrl = `${Config.env.API_URL_V2}projects/candidates/resume?resume_key=${candidate.resume_key}`;
      } else {
        resumeUrl = `${Config.env.API_URL}candidates/resume?candidate_id=${candidate._id}`;
      }
      axios
        .get(resumeUrl, {
          responseType: 'blob',
        })
        .then((response) => {
          if (response.status === 200) {
            const { headers } = response;
            const blob = new Blob([response.data], {
              type: headers['content-type'],
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = candidate._id;
            link.click();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleChange() {
      if (this.moveTo !== 'other_project') {
        this.movingProjectName = '';
        this.movingTabName = '';
      }
    },

    onMoveClick(moveTo) {
      this.moveTo = moveTo;
      this.handleChange();
      this.moveCard();
    },

    onNotInterectedClick(key) {
      this.moveTo = 'not_interested';
      this.movingNotInterestedReason = key;

      if (key === 8 || key === 1) {
        this.isMoveNotInterested = true;
      } else {
        this.moveCard();
      }
      this.move1 = false;
      this.move2 = false;
      this.move3 = false;
    },

    onOtherProjectClick(projectName, movingTabName) {
      const projectTarget = this.projects.find(
        (elem) => elem.project_id === projectName
      );
      let movingTab = movingTabName;
      if (!movingTabName) {
        movingTab = projectTarget.is_warmleads_recruiter
          ? 'WARM_LEADS_RECRUITER'
          : 'WARM_LEADS_HM';
      }

      this.move1 = false;
      this.move2 = false;
      this.move3 = false;
      this.moveTo = 'other_project';
      this.movingProjectName = projectName;
      this.movingTabName = movingTab;
      this.moveCard();
    },

    onMoveInterviewClick(moveTo) {
      this.moveTo = moveTo;
      this.interviewConfirmationDialog = true;
    },

    nextCandidate() {
      this.$emit('next-candidate');
    },

    previousCandidate() {
      this.$emit('prev-candidate');
    },

    expandEmail() {
      this.$emit('expand-email');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/card.scss';
.move-card-popup {
  border-radius: 6px !important;
  &__title {
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.2px;
  }
  &.show-project-list {
    width: 555px;
    z-index: 99;
    .projects-list {
      border-left: 1px solid rgba(0, 0, 0, 0.12);
      width: 50%;
      position: relative;
      margin-right: 6px;
      // max-height: 240px;
      .projects-list-content {
        overflow-y: scroll;
        position: absolute;
        top: 0px;
        left: 0px;
        height: 100%;
        width: 100%;
      }
      &__name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 260px;
      }
    }

    &.show-tab-list {
      .projects-list {
        border-left: 1px solid rgba(0, 0, 0, 0.12);
        width: 30%;
        overflow-y: auto;

        &__name {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100px;
        }
      }
    }
    .projects-tab {
      border-left: 1px solid rgba(0, 0, 0, 0.12);
      &::v-deep .v-label {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100px;
      }
    }
  }
  .other-project {
    width: 100px;
  }
}
.active-radio {
  &::v-deep .v-label {
    font-weight: 500;
  }
}
.gap-3 {
  gap: 12px;
}
.contact-date {
  font-weight: 400 !important;
  display: block;
  text-align: center;
  font-size: 10px;
  color: #0073bf;
}
.font-w-500 {
  font-weight: 500;
}
.info-icon {
  margin-top: -4px;
}

.w-custom-330 {
  width: 357px !important;
}

.reason-title {
  color: #111827;
  font-size: 14px;
}

::v-deep .v-input--radio-group__input > div {
  padding: 6px 16px;
}
// ::v-deep .v-input--radio-group__input > div:hover{
//   background: #F3F4F6;
// }
.rejected-flashing {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, 0);
}
.overlay2 {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 1;
  border-radius: 20px;
  top: 0px;
  left: -3px;
  width: calc(100% + 6px);
  height: calc(100% + 0px);
}
.z-10 {
  z-index: 10;
}
.no-bg {
  background-color: transparent;
}
.fake-card {
  position: absolute;
  top: 0px;
  overflow: hidden;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 20px 20px 0 0;
  img {
    width: 100%;
    transform: scale(1.05);
  }
}
.card-content {
  position: relative;
}
::v-deep {
  .v-tooltip__content {
    background: #616161 !important;
    opacity: 1 !important;
  }
}
.move-card-container {
  width: 200px !important;
}
</style>
